import 'constants/sass/custom.sass'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { HashRouter, Route } from 'react-router-dom'
import App from '../App'
import { Portal } from 'react-portal'
import { OnBoarding, Notifications, Popup, SecureChallengeWrapper } from 'containers'
import 'constants/sass/index.sass'
import * as serviceWorker from '../serviceWorker'
import store from '../store'
import 'formdata-polyfill'
import Dinero from 'dinero.js'
import 'survey-core/i18n/french'
import { settings } from 'survey-core'
import { Maintenance } from '../components/Maintenance/Maintenance'
settings.autoAdvanceDelay = 0

declare global {
  interface Window {
    gtag: (param: string, value: string | undefined, data?: object | undefined) => void
    analytics: {
      identify: (param: string, data?: object | undefined) => void
      track: (param: string, data?: object | undefined, settings?: object | undefined) => void
      page: (category?: string, name?: string, properties?: object) => void
    },
    dataLayer: any,
  }
}

Dinero.globalLocale = 'fr-FR'
Dinero.defaultCurrency = 'EUR'

const rootElement = document.getElementById('root-onboarding')

const RenderedPage = () => {
  if (process.env.REACT_APP_MAINTENANCE === '1') {
    return <Maintenance />
  } else {
    return (
      <Provider store={store}>
        <App>
          <HashRouter>
            <Route path="/" component={OnBoarding} />
          </HashRouter>
        </App>
        <Portal>
          <Notifications />
          <Popup />
          <SecureChallengeWrapper />
        </Portal>
      </Provider>
    )
  }
}

ReactDOM.render(
  <RenderedPage />,
  rootElement,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
